module.exports = __webpack_public_path__ + "static/media/amrut.07aae044.webp";